export interface ComicChapter {
  id: string;
  num: number;
  title: string;
  date: string;
  views: string;
}

export interface Comic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  author: string;
  year: number;
  intro: string;
  cover: string;
  chapters: ComicChapter[];
}

export const categories = [
  '全部',
  '热血冒险',
  '恋爱少女',
  '玄幻奇幻',
  '都市校园',
  '悬疑惊悚',
  '治愈日常',
  '科幻机战',
  '完结经典',
];

const covers = {
  hero1: 'https://readdy.ai/api/search-image?query=anime%20hero%20with%20flaming%20sword%20standing%20on%20cliff%20under%20warm%20sunset%2C%20dynamic%20action%20pose%2C%20vibrant%20vermilion%20and%20gold%20palette%2C%20detailed%20manga%20style%20cover%20art%2C%20dramatic%20lighting%20and%20epic%20atmosphere&width=600&height=800&seq=manga-hero1&orientation=portrait',
  cover1: 'https://readdy.ai/api/search-image?query=young%20swordsman%20with%20shining%20blade%20facing%20giant%20monster%2C%20warm%20sunset%20backdrop%2C%20manga%20cover%20art%2C%20action%20scene%2C%20bold%20composition%2C%20vibrant%20colors&width=600&height=800&seq=manga-cover1&orientation=portrait',
  cover2: 'https://readdy.ai/api/search-image?query=cute%20girl%20with%20cherry%20blossoms%20and%20sweet%20smile%2C%20romance%20manga%20cover%2C%20soft%20warm%20lighting%2C%20pastel%20tones%2C%20gentle%20aesthetic&width=600&height=800&seq=manga-cover2&orientation=portrait',
  cover3: 'https://readdy.ai/api/search-image?query=mysterious%20mage%20with%20glowing%20staff%20in%20ancient%20forest%2C%20fantasy%20manga%20cover%2C%20emerald%20and%20gold%20tones%2C%20magical%20mist%2C%20epic%20scene&width=600&height=800&seq=manga-cover3&orientation=portrait',
  cover4: 'https://readdy.ai/api/search-image?query=high%20school%20students%20walking%20on%20campus%20path%2C%20school%20manga%20cover%2C%20warm%20afternoon%20sunlight%2C%20youthful%20and%20bright%20mood&width=600&height=800&seq=manga-cover4&orientation=portrait',
  cover5: 'https://readdy.ai/api/search-image?query=detective%20in%20trench%20coat%20under%20dim%20rain%20street%20light%2C%20mystery%20manga%20cover%2C%20noir%20atmosphere%2C%20moody%20shadows&width=600&height=800&seq=manga-cover5&orientation=portrait',
  cover6: 'https://readdy.ai/api/search-image?query=girl%20with%20warm%20tea%20and%20sleeping%20cat%20by%20cozy%20window%2C%20slice%20of%20life%20manga%20cover%2C%20soft%20golden%20light%2C%20comforting%20warm%20tone&width=600&height=800&seq=manga-cover6&orientation=portrait',
  cover7: 'https://readdy.ai/api/search-image?query=mecha%20robot%20in%20space%20battle%2C%20sci-fi%20manga%20cover%2C%20warm%20orange%20nebula%20background%2C%20dynamic%20action%2C%20high%20detail&width=600&height=800&seq=manga-cover7&orientation=portrait',
  cover8: 'https://readdy.ai/api/search-image?query=classic%20samurai%20in%20moonlight%20with%20cherry%20petals%2C%20wuxia%20manga%20cover%2C%20atmospheric%2C%20ink%20painting%20style%20with%20warm%20accents&width=600&height=800&seq=manga-cover8&orientation=portrait',
  cover9: 'https://readdy.ai/api/search-image?query=energetic%20boy%20playing%20basketball%20under%20gym%20lights%2C%20sports%20manga%20cover%2C%20warm%20dynamic%20action%2C%20youthful%20energy&width=600&height=800&seq=manga-cover9&orientation=portrait',
  cover10: 'https://readdy.ai/api/search-image?query=young%20chef%20with%20steaming%20dish%20and%20sparkling%20ingredients%2C%20food%20manga%20cover%2C%20warm%20appetizing%20tones%2C%20happy%20expression&width=600&height=800&seq=manga-cover10&orientation=portrait',
  cover11: 'https://readdy.ai/api/search-image?query=group%20of%20adventurers%20climbing%20mysterious%20tower%2C%20fantasy%20adventure%20manga%20cover%2C%20epic%20warm%20lighting%2C%20team%20dynamic&width=600&height=800&seq=manga-cover11&orientation=portrait',
  cover12: 'https://readdy.ai/api/search-image?query=robot%20girl%20with%20glowing%20heart%20in%20futuristic%20city%2C%20sci-fi%20manga%20cover%2C%20warm%20neon%20highlights%2C%20emotional%20mood&width=600&height=800&seq=manga-cover12&orientation=portrait',
  cover13: 'https://readdy.ai/api/search-image?query=campfire%20scene%20with%20friends%20and%20stars%2C%20adventure%20manga%20cover%2C%20warm%20night%20tones%2C%20nostalgic%20and%20cozy&width=600&height=800&seq=manga-cover13&orientation=portrait',
  cover14: 'https://readdy.ai/api/search-image?query=shadow%20assassin%20silhouette%20in%20neon%20alley%2C%20thriller%20manga%20cover%2C%20moody%20warm%20contrast%2C%20tense%20atmosphere&width=600&height=800&seq=manga-cover14&orientation=portrait',
  cover15: 'https://readdy.ai/api/search-image?query=witch%20girl%20brewing%20potion%20in%20sunlit%20cottage%2C%20healing%20fantasy%20manga%20cover%2C%20soft%20warm%20pastel%20colors%2C%20gentle%20magic&width=600&height=800&seq=manga-cover15&orientation=portrait',
  cover16: 'https://readdy.ai/api/search-image?query=two%20swords%20crossed%20in%20front%20of%20setting%20sun%2C%20wuxia%20manga%20cover%2C%20dramatic%20warm%20sky%2C%20heroic%20composition&width=600&height=800&seq=manga-cover16&orientation=portrait',
  cover17: 'https://readdy.ai/api/search-image?query=cute%20robot%20companion%20and%20boy%20walking%20in%20ruins%2C%20sci-fi%20adventure%20manga%20cover%2C%20warm%20sunlight%20through%20clouds%2C%20hopeful%20mood&width=600&height=800&seq=manga-cover17&orientation=portrait',
  cover18: 'https://readdy.ai/api/search-image?query=dragon%20in%20sky%20over%20fantasy%20kingdom%2C%20fantasy%20manga%20cover%2C%20majestic%20warm%20lighting%2C%20epic%20scale%2C%20vivid%20colors&width=600&height=800&seq=manga-cover18&orientation=portrait',
  cover19: 'https://readdy.ai/api/search-image?query=music%20band%20girls%20performing%20on%20stage%2C%20music%20manga%20cover%2C%20warm%20spotlights%2C%20dynamic%20energy%2C%20passion&width=600&height=800&seq=manga-cover19&orientation=portrait',
  cover20: 'https://readdy.ai/api/search-image?query=knight%20with%20shield%20in%20blooming%20meadow%2C%20fantasy%20romance%20manga%20cover%2C%20soft%20warm%20light%2C%20gentle%20heroic%20mood&width=600&height=800&seq=manga-cover20&orientation=portrait',
};

const ch = (id: string, num: number, title: string, date: string, views: string): ComicChapter => ({
  id: `${id}-c${num}`,
  num,
  title,
  date,
  views,
});

function buildChapters(id: string, count: number, baseTitle: string, startDate: string): ComicChapter[] {
  const list: ComicChapter[] = [];
  for (let i = 1; i <= count; i += 1) {
    list.push(
      ch(id, i, `${baseTitle} 第${i}话`, `2026-0${(i % 8) + 1}-${((i * 3) % 27) + 1}`, `${(120 - i).toString()}万`),
    );
  }
  return list;
}

export const comics: Comic[] = [
  {
    id: 'c1', title: '烈焰剑客', category: '热血冒险', tags: ['热血', '战斗', '成长'], status: '连载中',
    rating: 9.6, views: '3.2亿', author: '南风漫', year: 2023,
    intro: '少年剑客林炎在一次意外中觉醒了上古炎之血脉，为守护家园踏上修行之路。一路斩妖除魔、结识伙伴，在热血与羁绊中不断突破自我。全集目录持续更新，热血长篇一集不落。',
    cover: covers.cover1,
    chapters: buildChapters('c1', 128, '烈焰剑客', ''),
  },
  {
    id: 'c2', title: '樱色初告白', category: '恋爱少女', tags: ['恋爱', '校园', '甜宠'], status: '连载中',
    rating: 9.2, views: '2.1亿', author: '晚风绘', year: 2024,
    intro: '普通少女樱子的青春恋爱物语。与青梅竹马、转校生之间青涩而甜蜜的故事，细腻的情感描写与温暖的画面，让每一话都令人心动。全本连载中，追更不迷路。',
    cover: covers.cover2,
    chapters: buildChapters('c2', 86, '樱色初告白', ''),
  },
  {
    id: 'c3', title: '星穹术士', category: '玄幻奇幻', tags: ['奇幻', '魔法', '冒险'], status: '连载中',
    rating: 9.4, views: '1.9亿', author: '墨羽工作室', year: 2022,
    intro: '天赋异禀的术士少年误入禁忌森林，觉醒星辰之力，逐渐揭开世界深处的秘密。宏大的世界观与精良的战斗场面，玄幻长篇力作，全集目录随手可读。',
    cover: covers.cover3,
    chapters: buildChapters('c3', 156, '星穹术士', ''),
  },
  {
    id: 'c4', title: '阳光高三班', category: '都市校园', tags: ['校园', '青春', '日常'], status: '已完结',
    rating: 8.8, views: '1.2亿', author: '晴空社', year: 2021,
    intro: '一群高三学生的日常群像剧。友情、梦想、考试与毕业，真实又温暖的校园生活被细腻刻画，完结全本资源一次看完，青春无悔。',
    cover: covers.cover4,
    chapters: buildChapters('c4', 96, '阳光高三班', ''),
  },
  {
    id: 'c5', title: '暗夜名侦探', category: '悬疑惊悚', tags: ['悬疑', '推理', '反转'], status: '连载中',
    rating: 9.5, views: '2.7亿', author: '夜枭漫', year: 2023,
    intro: '天才侦探在都市迷雾中破解连环谜案，每一话都是独立又相连的烧脑推理。层层反转、氛围紧张，悬疑惊悚爱好者不容错过。',
    cover: covers.cover5,
    chapters: buildChapters('c5', 74, '暗夜名侦探', ''),
  },
  {
    id: 'c6', title: '四月的猫与茶', category: '治愈日常', tags: ['治愈', '日常', '温馨'], status: '连载中',
    rating: 9.3, views: '1.5亿', author: '小满漫', year: 2024,
    intro: '在四月的小镇茶馆，少女与一只神秘猫咪的温馨日常。缓慢治愈的节奏、温柔的画面，让疲惫的心得到休憩，全本资源温暖收藏。',
    cover: covers.cover6,
    chapters: buildChapters('c6', 58, '四月的猫与茶', ''),
  },
  {
    id: 'c7', title: '机战纪元', category: '科幻机战', tags: ['科幻', '机甲', '燃'], status: '连载中',
    rating: 9.1, views: '2.3亿', author: '银翼机甲', year: 2022,
    intro: '人类在星际战争中驾驶机甲守护家园，少年与AI伙伴共同成长。宏大的宇宙战争场面与热血机战，科幻迷的视觉盛宴，全集持续整理。',
    cover: covers.cover7,
    chapters: buildChapters('c7', 118, '机战纪元', ''),
  },
  {
    id: 'c8', title: '月光浪客', category: '完结经典', tags: ['武侠', '经典', '江湖'], status: '已完结',
    rating: 9.8, views: '4.1亿', author: '江湖一梦', year: 2019,
    intro: '在月光下的江湖，一位浪客剑士的传奇。极致的写意画风与深厚剧情，被评为一代经典。完结全本资源打包，一次阅尽江湖恩怨。',
    cover: covers.cover8,
    chapters: buildChapters('c8', 212, '月光浪客', ''),
  },
  {
    id: 'c9', title: '灌篮少年', category: '热血冒险', tags: ['运动', '热血', '竞技'], status: '连载中',
    rating: 9.4, views: '2.9亿', author: '飞扬体育', year: 2023,
    intro: '热爱篮球的少年从菜鸟成长为球队核心，挥洒汗水的青春热血故事。比赛场面张力十足，运动番天花板，全本持续更新。',
    cover: covers.cover9,
    chapters: buildChapters('c9', 88, '灌篮少年', ''),
  },
  {
    id: 'c10', title: '舌尖上的餐厅', category: '治愈日常', tags: ['美食', '温馨', '经营'], status: '已完结',
    rating: 9.0, views: '1.8亿', author: '暖胃社', year: 2020,
    intro: '青年厨师继承祖父的小餐厅，用一道料理温暖一座城。美食与人间百态交织，治愈感满溢的完结之作，全集目录整齐可读。',
    cover: covers.cover10,
    chapters: buildChapters('c10', 120, '舌尖上的餐厅', ''),
  },
  {
    id: 'c11', title: '试炼之塔', category: '玄幻奇幻', tags: ['冒险', '塔防', '伙伴'], status: '连载中',
    rating: 9.2, views: '1.6亿', author: '逐塔人', year: 2024,
    intro: '一群冒险者挑战传说中的试炼之塔，每层都有全新谜题与强敌。友情与智慧并存的长篇冒险，追更补番两不误。',
    cover: covers.cover11,
    chapters: buildChapters('c11', 64, '试炼之塔', ''),
  },
  {
    id: 'c12', title: '机械少女心', category: '科幻机战', tags: ['科幻', '治愈', '感动'], status: '已完结',
    rating: 9.3, views: '2.0亿', author: '芯光漫', year: 2021,
    intro: '失去记忆的机械少女与青年科学家的相遇，冰冷机体下跳动着一颗温暖的心。科幻与治愈交融的感动之作，完结全本一次看够。',
    cover: covers.cover12,
    chapters: buildChapters('c12', 80, '机械少女心', ''),
  },
  {
    id: 'c13', title: '篝火之夏', category: '治愈日常', tags: ['夏日', '友情', '青春'], status: '连载中',
    rating: 8.9, views: '9800万', author: '拾光漫', year: 2025,
    intro: '一群少年在夏日露营、冒险、仰望星空的故事。清新治愈的画风与青春的悸动，让夏天永远留在这个小镇。',
    cover: covers.cover13,
    chapters: buildChapters('c13', 42, '篝火之夏', ''),
  },
  {
    id: 'c14', title: '夜行者', category: '悬疑惊悚', tags: ['都市', '超能力', '暗黑'], status: '连载中',
    rating: 9.1, views: '1.4亿', author: '影组织', year: 2023,
    intro: '隐藏在霓虹都市暗处的超能夜行者，游走在法律与正义的边缘。紧张刺激的都市暗黑物语，每一话都让人屏息。',
    cover: covers.cover14,
    chapters: buildChapters('c14', 70, '夜行者', ''),
  },
  {
    id: 'c15', title: '魔女的小屋', category: '恋爱少女', tags: ['魔法', '治愈', '恋爱'], status: '连载中',
    rating: 9.5, views: '2.4亿', author: '初雪漫', year: 2023,
    intro: '在阳光小镇的魔女小屋，见习魔女用心熬制每一瓶药水，也悄悄酝酿着温柔的心事。魔法、治愈与恋爱交织的少女物语。',
    cover: covers.cover15,
    chapters: buildChapters('c15', 66, '魔女的小屋', ''),
  },
  {
    id: 'c16', title: '双剑山河', category: '完结经典', tags: ['武侠', '家国', '史诗'], status: '已完结',
    rating: 9.7, views: '3.6亿', author: '山河漫', year: 2018,
    intro: '乱世之中，两位持剑者的宿命对决与家国情怀。史诗级武侠长篇，格局宏大、人物饱满，完结全本资源经典收藏。',
    cover: covers.cover16,
    chapters: buildChapters('c16', 188, '双剑山河', ''),
  },
  {
    id: 'c17', title: '废土旅人', category: '科幻机战', tags: ['末世', '冒险', '伙伴'], status: '连载中',
    rating: 9.0, views: '1.1亿', author: '废土漫', year: 2024,
    intro: '末世废土之上，少年与机器伙伴踏上寻找绿洲之旅。荒凉与温情并存，在绝望中守护希望，科幻冒险长篇持续更新。',
    cover: covers.cover17,
    chapters: buildChapters('c17', 52, '废土旅人', ''),
  },
  {
    id: 'c18', title: '苍穹龙骑', category: '热血冒险', tags: ['龙', '奇幻', '热血'], status: '连载中',
    rating: 9.4, views: '2.6亿', author: '龙翔漫', year: 2022,
    intro: '少年与契约之龙翱翔天际，守护王国、对抗黑暗。宏大空战场面与感人羁绊，热血奇幻长篇，全集目录随手可追。',
    cover: covers.cover18,
    chapters: buildChapters('c18', 102, '苍穹龙骑', ''),
  },
  {
    id: 'c19', title: '闪耀吧乐队', category: '都市校园', tags: ['音乐', '青春', '梦想'], status: '已完结',
    rating: 9.2, views: '1.7亿', author: '律动社', year: 2021,
    intro: '四位女孩组成乐队追逐音乐梦想，在舞台与生活中互相扶持。青春热血的音乐物语，完结全本，梦想永不散场。',
    cover: covers.cover19,
    chapters: buildChapters('c19', 76, '闪耀吧乐队', ''),
  },
  {
    id: 'c20', title: '花与骑士', category: '恋爱少女', tags: ['奇幻', '甜宠', '骑士'], status: '连载中',
    rating: 9.3, views: '2.2亿', author: '花语漫', year: 2023,
    intro: '身处花海王国的温柔骑士，与公主之间细水长流的守护之爱。唯美画风与细腻情感，少女心爆棚的长篇力作。',
    cover: covers.cover20,
    chapters: buildChapters('c20', 84, '花与骑士', ''),
  },
];

export const hotComics = comics.slice(0, 10);
export const latestComics = [...comics].sort((a, b) => a.year - b.year).slice(0, 10);

export function getComic(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}